// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.project-status[data-v-54c5f042] {\n  display: inline-block;\n  padding: 5px 8px;\n  border: 1px solid #fff;\n  border-radius: 4px;\n  color: #000;\n  text-align: center;\n}\n\n", ""]);
// Exports
module.exports = exports;
